<template>
    <div class="ibox form" v-if="section == 1">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-4 col-sm-offset-2">
                    <button
                        type="submit"
                        class="btn btn-primary btn-sm"
                        :data-cy="dataCy"
                    >
                        {{ text }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-else>
        <div class="col-sm-4 col-sm-offset-2">
            <button
                type="submit"
                class="btn btn-primary btn-sm"
                :data-cy="dataCy"
            >
                {{ text }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "SubmitButton",
    props: {
        storeRoute: {
            type: String,
            default: "#"
        },
        text: {
            type: String,
            default: 'Wyślij'
        },
        dataCy: {
            type: String,
            default: "",
        },
        section:{
            type:Number,
            default:1,
        }
    },
    methods: {
        checkClientDataExist(action) {
            let forms = document.querySelectorAll(".client-form");
            let formData = [];
            forms.forEach(element => {
                if(element !== null && element.querySelector(
                    'select[name="idNumberType[]"] option:checked'
                ) !== null){
                    let data = {
                        name: element.querySelector('input[name="name[]"]').value,
                        idNumberType: element.querySelector(
                            'select[name="idNumberType[]"] option:checked'
                        ).value,
                        idNumber: element.querySelector('input[name="idNumber[]"]')
                            .value,
                        adminLoginCompanyName:document.querySelector('input[name="admin_login_data[company]"]')
                            .value
                    };
                    formData.push(data);
                }

            });
            let self = this;
            this.checkUserDataExistsInSystemAsGuest(formData)

                .then(response => {
                    if(response.data.status === "OK"){
                        this[action]();
                    }
                    else if( response.data.validation_error !== null && response.data.validation_error.length > 0){
                        this.showErrorModalWithMessage(response.data.validation_error);
                    }

                })
                .catch(error => {
                    toastr["error"](self.__("failed_to_perform_action")).css(
                        "border",
                        "0px"
                    );
                });
        },
        showErrorModalWithMessage(message) {
            let self = this;
            this.$swal({
                title: self.__("warning_!"),
                text: message,
                icon: "error",
                confirmButtonColor: "#55dd82",
                confirmButtonText: self.capitalize(self.__("ok")),
                closeOnConfirm: true,
            }).then(result => {
                if (result.value == true) {

                }
            });
        },
        getMessageForType(type){
          switch (type){
              case 'USER_ALREADY_REGISTERED':
                  return ("Podmiot korzysta już z CONTsup. Zmień dane Podmiotu użytkującego")
          }
        },
        dataExistModal(action, companies) {
            let self = this;
            let companiesText = "";
            companies.forEach(company => {
                companiesText += `${company.clientName}, ${company.name} <br/>`;
            });
            let text = `${self.__(
                "the_user_entity_already_uses_cont_sup"
            )} <br/>  ${companiesText} ${self.__(
                "do_you_confirm_adding_a_second_user_with_the_same_id_number_?"
            )}`;
            this.$swal({
                title: self.__("warning_!"),
                html: text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#55dd82",
                confirmButtonText: self.capitalize(self.__("yes")),
                cancelButtonText: self.capitalize(self.__("no")),
                closeOnConfirm: true,
                reverseButtons: true
            }).then(result => {
                if (result.value == true) {
                    this[action]();
                }
            });
        },
        submit() {
            let form = document.getElementById("register-form");
            form.setAttribute("action", this.storeRoute);
            form.submit();
        },
        capitalize: function(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        ...mapActions(["checkUserDataExistsInSystemAsGuest"])

    }
}
</script>

<style scoped>

</style>
